import { safeJsonParse } from '@halo/utils';
import CryptoJS from 'crypto-js';
import type { MnemonicAccount } from '@halo/wallet-app';
import type { Account, SetExpiresTimeArgs, uploadArgs } from './types';

export const setLoginExpiresTime = ({ platform, cid, expiresTime }: SetExpiresTimeArgs) => {
  const jsonData = window.localStorage.getItem('loginExpirationTime') || '';
  const data = safeJsonParse<Record<string, any>>(jsonData, {});
  const newData = {
    ...data,
    [platform]: {
      ...(data[platform] || {}),
      [cid]: expiresTime,
    },
  };
  window.localStorage.setItem('loginExpirationTime', JSON.stringify(newData));
};

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const deleteIcloudCookie = (containerId: string) => {
  deleteCookie(containerId);
  deleteCookie('X-APPLE-WEBAUTH-AC-PARTITION');
  deleteCookie('X-APPLE-WEBAUTH-AC-SERVERINFO');
  deleteCookie('X-APPLE-WEBAUTH-AC-TOKEN');
  localStorage.removeItem(containerId);
};

export const getPrivateFile = (params: { key: string }) => {
  return btoa(`${params.key}/password`);
};
export const getPrivateFileV2 = (params: { key: string; subId?: string }) => {
  return CryptoJS.MD5(`${params.key}/${params.subId}`).toString();
};

export const getMetadata = (params: { key: string; subId?: string }) => {
  return {
    name: params.subId ? getPrivateFileV2(params) : getPrivateFile(params),
    mimeType: 'text/plain',
  };
};

export async function withUpdateTime<T>(data: T) {
  return {
    ...data,
    // TODO amo: Get server time
    t: Date.now(),
  };
}

export function formatAccountsData(accounts: Account[]) {
  return accounts?.map(
    ({
      id,
      name,
      isDefault,
      derivedWallets,
      uid,
      clientUid,
      type,
      mnemonic,
      nextAddressIndex,
    }) => {
      const obj: Partial<MnemonicAccount> = {};
      if (mnemonic) {
        obj.mnemonic = mnemonic;
        obj.nextAddressIndex = nextAddressIndex;
      }
      return {
        id,
        name,
        isDefault,
        derivedWallets,
        uid,
        clientUid,
        type,
        ...obj,
      };
    }
  );
}

export async function formatWalletData({
  accounts,
  isChange,
  password,
  ...rest
}: Omit<Required<uploadArgs['data']>['wallet'], 't' | 'version'>) {
  const accounts_ = formatAccountsData(accounts);

  return withUpdateTime({
    isChange,
    password,
    accounts: accounts_,
    ...rest,
    version: 2,
  });
}
